import * as React from 'react';
import { cn } from '@/lib/utils';

const EssaySendHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-essay-send-header', 'mb-8 text-end', className)}
    {...props}
  />
));
EssaySendHeader.displayName = 'EssaySendHeader';

const EssaySendBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-essay-send-header', 'flex flex-wrap gap-9', className)}
    {...props}
  />
));
EssaySendBody.displayName = 'EssaySendBody';

const EssaySendCard = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('essay-send-card', 'flex min-w-full max-w-full flex-grow basis-0 flex-col overflow-auto rounded-[1rem] bg-white p-3', 'md:min-w-[400px] md:max-w-[50%]', 'min-[1192px]:h-[700px]', className)}
    {...props}
  />
));
EssaySendCard.displayName = 'EssaySendCard';

const EssaySendCardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('essay-send-card-header', 'flex items-center justify-between p-[18px]', className)}
    {...props}
  />
));
EssaySendCardHeader.displayName = 'EssaySendCardHeader';

const EssaySendCardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('essay-send-card-header-title', 'font-bold', className)}
    {...props}
  />
));
EssaySendCardTitle.displayName = 'EssaySendCardTitle';

const EssaySendCardPlaceholder = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('essay-send-card-placeholder', 'flex h-full items-center justify-center rounded-lg border-[3px] border-dashed border-neutral-light p-6', className)}
    {...props}
  />
));
EssaySendCardPlaceholder.displayName = 'EssaySendCardPlaceholder';

const EssaySendCardTextarea = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-essay-send-card-textarea',
      // Estilos do container
      'flex flex-grow overflow-y-auto rounded-[10px] border border-solid border-[#ece9f8] bg-[#f1f5fa]',
      // Estilos aplicados ao textarea
      '[&_textarea]:w-full [&_textarea]:resize-none [&_textarea]:bg-transparent [&_textarea]:p-3 [&_textarea]:font-["Nunito",sans-serif] [&_textarea]:text-[14px] [&_textarea]:leading-[21px] [&_textarea]:text-[#5d6a86]',
      // Reset total de borda, outline e ring no estado normal e de focus
      '[&_textarea]:border-none [&_textarea]:outline-none [&_textarea]:ring-0',
      '[&_textarea:focus]:border-none [&_textarea:focus]:outline-none [&_textarea:focus]:ring-0',
      // Estilos aplicados ao p
      '[&_p]:w-full [&_p]:p-3 [&_p]:font-["Nunito",sans-serif] [&_p]:text-[14px] [&_p]:leading-[21px] [&_p]:text-[#5d6a86]',
      className
    )}
    {...props}
  >
    {children}
  </div>
));
EssaySendCardTextarea.displayName = 'EssaySendCardTextarea';

export { EssaySendHeader, EssaySendBody, EssaySendCard, EssaySendCardHeader, EssaySendCardTitle, EssaySendCardPlaceholder, EssaySendCardTextarea };
